module.exports = __webpack_public_path__ + "images/emoji/bento.24083c0ed72da3286eb6.png";